// extracted by mini-css-extract-plugin
export var alertIcon = "_tx-0";